import React from "react";
import SubHeadingBanner from "../components/organisms/SubHeadingBanner";
import ServicesNav from "../components/ServicesNav";
import useScrollToTop from "../hooks/useScrollToTop";
import { Outlet } from "react-router-dom";
import workwithMN from "../assets/images/workwithmn.avif"

function WorkWithMN() {
  useScrollToTop();
  return (
    <div>
      <SubHeadingBanner
        imageSrc={workwithMN}
        head1="Home - Work with MN"
        head2="Work with MN"
      />
      <ServicesNav />
      <Outlet />
    </div>
  );
}

export default WorkWithMN;
